import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import cx from 'classnames';
import { Menu } from '@cainiaofe/cn-ui';
import { obj, func, dom } from "../../utils";
import CascaderMenu from "./menu";
import CascaderMenuItem from "./item";
import { filterChildValue, getAllCheckedValues, forEachEnableNode, isSiblingOrSelf, isDescendantOrSelf, isNodeChecked } from "./utils";

// import '@alife/cn-ui/_fusion/lib/cascader/main.scss';

var bindCtx = func.bindCtx;
var pickOthers = obj.pickOthers;
var addClass = dom.addClass,
  removeClass = dom.removeClass,
  setStyle = dom.setStyle,
  getStyle = dom.getStyle;

// 数据打平
var flatDataSource = function flatDataSource(data, prefix, v2n, p2n) {
  if (prefix === void 0) {
    prefix = '0';
  }
  if (v2n === void 0) {
    v2n = {};
  }
  if (p2n === void 0) {
    p2n = {};
  }
  for (var index = 0; index < data.length; index++) {
    var item = data[index];
    var value = item.value,
      children = item.children;
    var pos = prefix + "-" + index;
    var newValue = String(value);
    item.value = newValue;
    v2n[newValue] = p2n[pos] = _extends({}, item, {
      pos: pos,
      _source: item
    });
    if (children && children.length) {
      flatDataSource(children, pos, v2n, p2n);
    }
  }
  return {
    v2n: v2n,
    p2n: p2n
  };
};
var getExpandedValue = function getExpandedValue(v, _v2n, _p2n) {
  if (!v || !_v2n[v]) {
    return [];
  }
  var pos = _v2n[v].pos;
  if (pos.split('-').length === 2) {
    return [];
  }
  var expandedMap = {};
  Object.keys(_p2n).forEach(function (p) {
    if (isDescendantOrSelf(p, pos) && p !== pos) {
      expandedMap[_p2n[p].value] = p;
    }
  });
  return Object.keys(expandedMap).sort(function (prev, next) {
    return expandedMap[prev].split('-').length - expandedMap[next].split('-').length;
  });
};
var normalizeValue = function normalizeValue(value) {
  if (value) {
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  }
  return [];
};

/**
 * Cascader
 */
var Cascader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Cascader, _Component);
  function Cascader(props, context) {
    var _this;
    _this = _Component.call(this, props, context) || this;
    var defaultValue = props.defaultValue,
      value = props.value,
      defaultExpandedValue = props.defaultExpandedValue,
      expandedValue = props.expandedValue,
      multiple = props.multiple,
      checkStrictly = props.checkStrictly,
      canOnlyCheckLeaf = props.canOnlyCheckLeaf,
      loadData = props.loadData,
      v2n = props.v2n,
      p2n = props.p2n;
    var normalizedValue = normalizeValue(typeof value === 'undefined' ? defaultValue : value);
    if (!loadData) {
      normalizedValue = normalizedValue.filter(function (v) {
        return v2n[v];
      });
    }
    var realExpandedValue = typeof expandedValue === 'undefined' ? typeof defaultExpandedValue === 'undefined' ? getExpandedValue(normalizedValue[0], v2n, p2n) : normalizeValue(defaultExpandedValue) : normalizeValue(expandedValue);
    var st = {
      value: normalizedValue,
      expandedValue: realExpandedValue
    };
    if (multiple && !checkStrictly && !canOnlyCheckLeaf) {
      st.value = getAllCheckedValues(st.value, v2n, p2n);
    }
    _this.lastExpandedValue = [].concat(st.expandedValue);
    _this.state = _extends({}, st, {
      _v2n: v2n,
      _p2n: p2n
    });
    bindCtx(_assertThisInitialized(_this), ['handleMouseLeave', 'handleFocus', 'handleFold', 'getCascaderNode', 'onBlur']);
    return _this;
  }
  Cascader.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var states = {};
    var v2n = props.v2n,
      p2n = props.p2n;
    if ('value' in props) {
      states.value = normalizeValue(props.value);
      if (!props.loadData) {
        states.value = states.value.filter(function (v) {
          return v2n[v];
        });
      }
      var multiple = props.multiple,
        checkStrictly = props.checkStrictly,
        canOnlyCheckLeaf = props.canOnlyCheckLeaf;
      if (multiple && !checkStrictly && !canOnlyCheckLeaf) {
        states.value = getAllCheckedValues(states.value, v2n, p2n);
      }
      if (!state.expandedValue.length && !('expandedValue' in props)) {
        states.expandedValue = getExpandedValue(states.value[0], v2n, p2n);
      }
    }
    if ('expandedValue' in props) {
      states.expandedValue = normalizeValue(props.expandedValue);
    }
    return _extends({}, states, {
      _v2n: v2n,
      _p2n: p2n
    });
  };
  var _proto = Cascader.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.setCascaderInnerWidth();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.setCascaderInnerWidth();
  };
  _proto.getCascaderNode = function getCascaderNode(ref) {
    this.cascader = ref;
    if (this.cascader) {
      this.cascaderInner = this.cascader.querySelector("." + this.props.prefix + "cascader-inner");
    }
  };
  _proto.setCascaderInnerWidth = function setCascaderInnerWidth() {
    if (!this.cascaderInner) {
      return;
    }
    var menus = [].slice.call(this.cascaderInner.querySelectorAll("." + this.props.prefix + "cascader-menu-wrapper"));
    if (menus.length === 0) {
      return;
    }
    var menusWidth = Math.ceil(menus.reduce(function (ret, menu) {
      return ret + Math.ceil(menu.getBoundingClientRect().width);
    }, 0));
    if (getStyle(this.cascaderInner, 'width') !== menusWidth) {
      setStyle(this.cascaderInner, 'width', menusWidth);
    }
    if (getStyle(this.cascader, 'display') === 'inline-block') {
      var hasRightBorderClass = this.props.prefix + "has-right-border";
      menus.forEach(function (menu) {
        return removeClass(menu, hasRightBorderClass);
      });
      if (this.cascader.clientWidth > menusWidth) {
        addClass(menus[menus.length - 1], hasRightBorderClass);
      }
    }
  }

  /*eslint-enable*/;
  _proto.flatValue = function flatValue(value) {
    return filterChildValue(value, this.state._v2n, this.state._p2n);
  };
  _proto.getValue = function getValue(pos) {
    return this.state._p2n[pos] ? this.state._p2n[pos].value : null;
  };
  _proto.getPos = function getPos(value) {
    return this.state._v2n[value] ? this.state._v2n[value].pos : null;
  };
  _proto.getData = function getData(value) {
    var _this2 = this;
    return value.map(function (v) {
      return _this2.state._v2n[v];
    });
  };
  _proto.processValue = function processValue(value, v, checked) {
    var index = value.indexOf(v);
    if (checked && index === -1) {
      value.push(v);
    } else if (!checked && index > -1) {
      value.splice(index, 1);
    }
  };
  _proto.handleSelect = function handleSelect(v, canExpand) {
    var _this3 = this;
    if (!(this.props.canOnlySelectLeaf && canExpand)) {
      var data = this.state._v2n[v];
      var nums = data.pos.split('-');
      var selectedPath = nums.slice(1).reduce(function (ret, num, index) {
        var p = nums.slice(0, index + 2).join('-');
        ret.push(_this3.state._p2n[p]);
        return ret;
      }, []);
      if (this.state.value[0] !== v) {
        if (!('value' in this.props)) {
          this.setState({
            value: [v]
          });
        }
        if ('onChange' in this.props) {
          this.props.onChange(v, data, {
            selectedPath: selectedPath
          });
        }
      }
      if ('onSelect' in this.props) {
        this.props.onSelect(v, data, {
          selectedPath: selectedPath
        });
      }
    }
    if (canExpand) {
      if (!this.props.canOnlySelectLeaf) {
        this.lastExpandedValue = this.state.expandedValue.slice(0, -1);
      }
    } else {
      this.lastExpandedValue = [].concat(this.state.expandedValue);
    }
  }
  /*eslint-disable max-statements*/;
  _proto.handleCheck = function handleCheck(v, checked) {
    var _this4 = this;
    var _this$props = this.props,
      checkStrictly = _this$props.checkStrictly,
      canOnlyCheckLeaf = _this$props.canOnlyCheckLeaf;
    var value = [].concat(this.state.value);
    if (checkStrictly || canOnlyCheckLeaf) {
      this.processValue(value, v, checked);
    } else {
      var pos = this.getPos(v);
      var ps = Object.keys(this.state._p2n);
      forEachEnableNode(this.state._v2n[v], function (node) {
        if (node.checkable === false) return;
        _this4.processValue(value, node.value, checked);
      });
      var currentPos = pos;
      var nums = pos.split('-');
      for (var i = nums.length; i > 2; i--) {
        var parentCheck = true;
        var parentPos = nums.slice(0, i - 1).join('-');
        if (this.state._p2n[parentPos].disabled || this.state._p2n[parentPos].checkboxDisabled || this.state._p2n[parentPos].checkable === false) {
          currentPos = parentPos;
          continue;
        }
        var parentValue = this.state._p2n[parentPos].value;
        var parentChecked = value.indexOf(parentValue) > -1;
        if (!checked && !parentChecked) {
          break;
        }
        for (var j = 0; j < ps.length; j++) {
          var p = ps[j];
          var pnode = this.state._p2n[p];
          if (isSiblingOrSelf(currentPos, p) && !pnode.disabled && !pnode.checkboxDisabled) {
            var k = pnode.value;
            // eslint-disable-next-line max-depth
            if (pnode.checkable === false) {
              // eslint-disable-next-line max-depth
              if (!pnode.children || pnode.children.length === 0) {
                continue;
              }
              // eslint-disable-next-line max-depth
              for (var m = 0; m < pnode.children.length; m++) {
                // eslint-disable-next-line max-depth
                if (!pnode.children.every(function (child) {
                  return isNodeChecked(child, value);
                })) {
                  parentCheck = false;
                  break;
                }
              }
              // 这里value 已经把父级去掉了
            } else if (value.indexOf(k) === -1) {
              parentCheck = false;
            }
            if (!parentCheck) break;
          }
        }
        this.processValue(value, parentValue, parentCheck);
        currentPos = parentPos;
      }
    }
    if (!('value' in this.props)) {
      this.setState({
        value: value
      });
    }
    if ('onChange' in this.props) {
      // flatValue 收缩
      var flatValue = this.flatValue(value);
      var flatData = this.getData(flatValue);
      var checkedData = this.getData(value);
      var indeterminateValue = this.getIndeterminate(value);
      var indeterminateData = this.getData(indeterminateValue);
      var chainData = [];
      flatData.forEach(function (item) {
        var filterChainData = indeterminateData.filter(
        // 根据pos匹配父级，从起始配置匹配到才算成功，中间位置的无效
        function (o) {
          return item.pos.indexOf(o.pos) === 0;
        });
        filterChainData.push(item);
        filterChainData.sort(function (a, b) {
          return a.level - b.level;
        });
        chainData.push(filterChainData);
      });
      if (checkStrictly || canOnlyCheckLeaf) {
        var data = this.getData(value);
        this.props.onChange(value, data, {
          checked: checked,
          currentData: this.state._v2n[v],
          checkedData: checkedData,
          indeterminateData: indeterminateData,
          chainData: chainData
        });
      } else {
        this.props.onChange(flatValue, flatData, {
          checked: checked,
          currentData: this.state._v2n[v],
          checkedData: checkedData,
          indeterminateData: indeterminateData,
          chainData: chainData
        });
      }
    }
    this.lastExpandedValue = [].concat(this.state.expandedValue);
  };
  _proto.handleExpand = function handleExpand(value, level, canExpand, focusedFirstChild) {
    var _this5 = this;
    var expandedValue = this.state.expandedValue;
    if (canExpand || expandedValue.length > level) {
      if (canExpand) {
        expandedValue.splice(level, expandedValue.length - level, value);
      } else {
        expandedValue.splice(level);
      }
      var callback = function callback() {
        _this5.setExpandValue(expandedValue);
        if (focusedFirstChild) {
          var endExpandedValue = expandedValue[expandedValue.length - 1];
          _this5.setState({
            focusedValue: _this5.state._v2n[endExpandedValue].children[0].value
          });
        }
      };
      var loadData = this.props.loadData;
      if (canExpand && loadData) {
        var data = this.state._v2n[value];
        return loadData(data, data._source).then(callback);
      } else {
        return callback();
      }
    }
  };
  _proto.handleMouseLeave = function handleMouseLeave() {
    this.setExpandValue([].concat(this.lastExpandedValue));
  };
  _proto.setExpandValue = function setExpandValue(expandedValue) {
    if (!('expandedValue' in this.props)) {
      this.setState({
        expandedValue: expandedValue
      });
    }
    if ('onExpand' in this.props) {
      this.props.onExpand(expandedValue);
    }
  };
  _proto.getFirstFocusKeyByDataSource = function getFirstFocusKeyByDataSource(dataSource) {
    if (!dataSource || dataSource.length === 0) {
      return '';
    }
    for (var i = 0; i < dataSource.length; i++) {
      if (dataSource[i] && !dataSource[i].disabled) {
        return dataSource[i].value;
      }
    }
    return '';
  };
  _proto.getFirstFocusKeyByFilteredPaths = function getFirstFocusKeyByFilteredPaths(filteredPaths) {
    if (!filteredPaths || filteredPaths.length === 0) {
      return '';
    }
    for (var i = 0; i < filteredPaths.length; i++) {
      var path = filteredPaths[i];
      if (!path.some(function (item) {
        return item.disabled;
      })) {
        var lastItem = path[path.length - 1];
        return lastItem.value;
      }
    }
    return '';
  };
  _proto.getFirstFocusKey = function getFirstFocusKey() {
    var _this$props2 = this.props,
      dataSource = _this$props2.dataSource,
      searchValue = _this$props2.searchValue,
      filteredPaths = _this$props2.filteredPaths;
    return !searchValue ? this.getFirstFocusKeyByDataSource(dataSource) : this.getFirstFocusKeyByFilteredPaths(filteredPaths);
  };
  _proto.setFocusValue = function setFocusValue() {
    this.setState({
      focusedValue: this.getFirstFocusKey()
    });
  };
  _proto.handleFocus = function handleFocus(focusedValue) {
    this.setState({
      focusedValue: focusedValue
    });
  };
  _proto.handleFold = function handleFold() {
    var expandedValue = this.state.expandedValue;
    if (expandedValue.length > 0) {
      this.setExpandValue(expandedValue.slice(0, -1));
    }
    this.setState({
      focusedValue: expandedValue[expandedValue.length - 1]
    });
  };
  _proto.getIndeterminate = function getIndeterminate(value) {
    var _this6 = this;
    var indeterminateValues = [];
    var poss = filterChildValue(value.filter(function (v) {
      return !!_this6.state._v2n[v];
    }).filter(function (v) {
      return !_this6.state._v2n[v].disabled && !_this6.state._v2n[v].checkboxDisabled && _this6.state._v2n[v].checkable !== false;
    }), this.state._v2n, this.state._p2n).map(function (v) {
      return _this6.state._v2n[v].pos;
    });
    poss.forEach(function (pos) {
      var nums = pos.split('-');
      for (var i = nums.length; i > 2; i--) {
        var parentPos = nums.slice(0, i - 1).join('-');
        var parent = _this6.state._p2n[parentPos];
        if (parent.disabled || parent.checkboxDisabled) break;
        var parentValue = parent.value;
        if (indeterminateValues.indexOf(parentValue) === -1) {
          indeterminateValues.push(parentValue);
        }
      }
    });
    return indeterminateValues;
  };
  _proto.onBlur = function onBlur(e) {
    this.setState({
      focusedValue: undefined
    });
    this.props.onBlur && this.props.onBlur(e);
  };
  _proto.renderMenu = function renderMenu(data, level) {
    var _this7 = this;
    var _this$props3 = this.props,
      prefix = _this$props3.prefix,
      multiple = _this$props3.multiple,
      useVirtual = _this$props3.useVirtual,
      checkStrictly = _this$props3.checkStrictly,
      expandTriggerType = _this$props3.expandTriggerType,
      loadData = _this$props3.loadData,
      canOnlyCheckLeaf = _this$props3.canOnlyCheckLeaf,
      listClassName = _this$props3.listClassName,
      listStyle = _this$props3.listStyle,
      itemRender = _this$props3.itemRender;
    var _this$state = this.state,
      value = _this$state.value,
      expandedValue = _this$state.expandedValue,
      focusedValue = _this$state.focusedValue;
    return /*#__PURE__*/React.createElement(CascaderMenu, {
      key: level,
      prefix: prefix,
      useVirtual: useVirtual,
      className: listClassName,
      style: listStyle,
      ref: this.saveMenuRef,
      focusedKey: focusedValue,
      onItemFocus: this.handleFocus,
      onBlur: this.onBlur
    }, data.map(function (item) {
      var disabled = !!item.disabled;
      var canExpand = !!item.children && !!item.children.length || !!loadData && !item.isLeaf;
      var expanded = expandedValue[level] === item.value;
      var props = {
        prefix: prefix,
        disabled: disabled,
        canExpand: canExpand,
        expanded: expanded,
        expandTriggerType: expandTriggerType,
        onExpand: _this7.handleExpand.bind(_this7, item.value, level, canExpand),
        onFold: _this7.handleFold
      };
      if ('title' in item) {
        props.title = item.title;
      }
      if (multiple) {
        props.checkable = !(canOnlyCheckLeaf && canExpand);
        props.checked = value.indexOf(item.value) > -1 || !!item.checked;
        props.indeterminate = (checkStrictly || canOnlyCheckLeaf ? false : _this7.indeterminate.indexOf(item.value) > -1) || !!item.indeterminate;
        props.checkboxDisabled = !!item.checkboxDisabled;
        props.onCheck = _this7.handleCheck.bind(_this7, item.value);
      } else {
        props.selected = value[0] === item.value;
        props.onSelect = _this7.handleSelect.bind(_this7, item.value, canExpand);
      }
      return /*#__PURE__*/React.createElement(CascaderMenuItem, _extends({
        key: item.value
      }, props), itemRender(item));
    }));
  };
  _proto.renderMenus = function renderMenus() {
    var dataSource = this.props.dataSource;
    var expandedValue = this.state.expandedValue;
    var menus = [];
    var data = dataSource;
    for (var i = 0; i <= expandedValue.length; i++) {
      if (!data) {
        break;
      }
      menus.push(this.renderMenu(data, i));
      var expandedItem = void 0;
      for (var j = 0; j < data.length; j++) {
        if (data[j].value === expandedValue[i]) {
          expandedItem = data[j];
          break;
        }
      }
      data = expandedItem ? expandedItem.children : null;
    }
    return menus;
  };
  _proto.renderFilteredItem = function renderFilteredItem(path) {
    var _this$props4 = this.props,
      prefix = _this$props4.prefix,
      resultRender = _this$props4.resultRender,
      searchValue = _this$props4.searchValue,
      multiple = _this$props4.multiple;
    var value = this.state.value;
    var lastItem = path[path.length - 1];
    var Item;
    var props = {
      key: lastItem.value,
      className: prefix + "cascader-filtered-item",
      disabled: path.some(function (item) {
        return item.disabled;
      }),
      children: resultRender(searchValue, path)
    };
    if (multiple) {
      Item = Menu.CheckboxItem;
      var _this$props5 = this.props,
        checkStrictly = _this$props5.checkStrictly,
        canOnlyCheckLeaf = _this$props5.canOnlyCheckLeaf;
      props.checked = value.indexOf(lastItem.value) > -1;
      props.indeterminate = !checkStrictly && !canOnlyCheckLeaf && this.indeterminate.indexOf(lastItem.value) > -1;
      props.checkboxDisabled = lastItem.checkboxDisabled;
      props.onChange = this.handleCheck.bind(this, lastItem.value);
    } else {
      Item = Menu.Item;
      props.selected = value[0] === lastItem.value;
      props.onSelect = this.handleSelect.bind(this, lastItem.value, false);
    }
    return /*#__PURE__*/React.createElement(Item, props);
  };
  _proto.renderFilteredList = function renderFilteredList() {
    var _this8 = this;
    var _this$props6 = this.props,
      prefix = _this$props6.prefix,
      filteredListStyle = _this$props6.filteredListStyle,
      filteredPaths = _this$props6.filteredPaths;
    var focusedValue = this.state.focusedValue;
    return /*#__PURE__*/React.createElement(Menu
    // 如果不设置为false， CascaderSelect 开启 showSearch后，弹窗展开时，光标无法到input上去，也无法输入
    , {
      focusable: false,
      focusedKey: focusedValue,
      onItemFocus: this.handleFocus,
      className: prefix + "cascader-filtered-list",
      style: filteredListStyle
    }, filteredPaths.map(function (path) {
      return _this8.renderFilteredItem(path);
    }));
  };
  _proto.render = function render() {
    var _cx;
    var _this$props7 = this.props,
      prefix = _this$props7.prefix,
      rtl = _this$props7.rtl,
      className = _this$props7.className,
      expandTriggerType = _this$props7.expandTriggerType,
      multiple = _this$props7.multiple,
      dataSource = _this$props7.dataSource,
      checkStrictly = _this$props7.checkStrictly,
      canOnlyCheckLeaf = _this$props7.canOnlyCheckLeaf,
      searchValue = _this$props7.searchValue;
    var others = pickOthers(Object.keys(Cascader.propTypes), this.props);
    var value = this.state.value;
    if (rtl) {
      others.dir = 'rtl';
    }
    var props = _extends({
      className: cx((_cx = {}, _cx[prefix + "cascader"] = true, _cx.multiple = multiple, _cx[className] = !!className, _cx)),
      ref: 'cascader'
    }, others);
    if (expandTriggerType === 'hover') {
      props.onMouseLeave = this.handleMouseLeave;
    }
    if (multiple && !checkStrictly && !canOnlyCheckLeaf) {
      this.indeterminate = this.getIndeterminate(value);
    }
    return /*#__PURE__*/React.createElement("div", _extends({}, props, {
      ref: this.getCascaderNode
    }), !searchValue ? /*#__PURE__*/React.createElement("div", {
      className: prefix + "cascader-inner"
    }, dataSource && dataSource.length ? this.renderMenus() : null) : this.renderFilteredList());
  };
  return Cascader;
}(Component);
Cascader.propTypes = {
  prefix: PropTypes.string,
  rtl: PropTypes.bool,
  pure: PropTypes.bool,
  className: PropTypes.string,
  /**
   * 数据源，结构可参考下方说明
   */
  dataSource: PropTypes.arrayOf(PropTypes.object),
  /**
   * （非受控）默认值
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * （受控）当前值
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * 选中值改变时触发的回调函数
   * @param {String|Array} value 选中的值，单选时返回单个值，多选时返回数组
   * @param {Object|Array} data 选中的数据，包括 value 和 label，单选时返回单个值，多选时返回数组，父子节点选中关联时，同时选中，只返回父节点
   * @param {Object} extra 额外参数
   * @param {Array} extra.selectedPath 单选时选中的数据的路径
   * @param {Boolean} extra.checked 多选时当前的操作是选中还是取消选中
   * @param {Object} extra.currentData 多选时当前操作的数据
   * @param {Array} extra.checkedData 多选时所有被选中的数据
   * @param {Array} extra.indeterminateData 多选时半选的数据
   * @param {Array} extra.chainData 多选时所选链数据
   */
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  /**
   * （非受控）默认展开值，如果不设置，组件内部会根据 defaultValue/value 进行自动设置
   */
  defaultExpandedValue: PropTypes.arrayOf(PropTypes.string),
  /**
   * （受控）当前展开值
   */
  expandedValue: PropTypes.arrayOf(PropTypes.string),
  /**
   * 展开触发的方式
   */
  expandTriggerType: PropTypes.oneOf(['click', 'hover']),
  /**
   * 展开时触发的回调函数
   * @param {Array} expandedValue 各列展开值的数组
   */
  onExpand: PropTypes.func,
  /**
   * 是否开启虚拟滚动
   */
  useVirtual: PropTypes.bool,
  /**
   * 是否多选
   */
  multiple: PropTypes.bool,
  /**
   * 单选时是否只能选中叶子节点
   */
  canOnlySelectLeaf: PropTypes.bool,
  /**
   * 多选时是否只能选中叶子节点
   */
  canOnlyCheckLeaf: PropTypes.bool,
  /**
   * 父子节点是否选中不关联
   */
  checkStrictly: PropTypes.bool,
  /**
   * 每列列表样式对象
   */
  listStyle: PropTypes.object,
  /**
   * 每列列表类名
   */
  listClassName: PropTypes.string,
  /**
   * 每列列表项渲染函数
   * @param {Object} data 数据
   * @return {ReactNode} 列表项内容
   */
  itemRender: PropTypes.func,
  /**
   * 异步加载数据函数
   * @param {Object} data 当前点击异步加载的数据
   * @param {Object} source 当前点击数据，source是原始对象
   */
  loadData: PropTypes.func,
  searchValue: PropTypes.string,
  onBlur: PropTypes.func,
  filteredPaths: PropTypes.array,
  filteredListStyle: PropTypes.object,
  resultRender: PropTypes.func,
  /**
   * 是否是不可变数据
   * @version 1.23
   */
  immutable: PropTypes.bool
};
Cascader.defaultProps = {
  prefix: 'cn-next-',
  rtl: false,
  pure: false,
  dataSource: [],
  defaultValue: null,
  canOnlySelectLeaf: false,
  canOnlyCheckLeaf: false,
  expandTriggerType: 'click',
  multiple: false,
  useVirtual: false,
  checkStrictly: false,
  itemRender: function itemRender(item) {
    return item.label;
  },
  immutable: false
};
export default polyfill(Cascader);